 import React, { Component } from 'react';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import Step5 from './Step5';
import Step6 from './Step6';
import StepThankYou from './StepThankYou';
import API from '../services/api';
import { auth, db } from '../firebase';

class RegistrationForm extends Component {
  constructor(props) {
    super(props);
    const code = props.match.params.code;
    let fields = {};
    if(typeof code !== 'undefined') {
      fields = {
        refCode: code,
      };
    }
    this.state = {
      currentStep: 1,
      fields,
      user: {},
    };
  }

  handleSubmit() {
    let { fields } = this.state;

    fields.birthDate = `${fields.dob_y}-${fields.dob_m}-${fields.dob_d}`;
    auth.doCreateUserWithEmailAndPassword(fields.email, fields.password)
      .then(authUser => {
        (new API()).post('/register', fields )
          .then(response => {
            if(response.success) {
              db.doCreateUser(response.user.id, response.user.name, response.user.email);
              this.setState({user: response.user});
              this.handleStepChange(7);
            }
          });
      })
      .catch(error => {
        this.setState({ 'error': error});
      });
  };

  handleStepChange = (i) => {
    this.setState({
      currentStep: i,
    });
  }

  handleDataSave(fields,submit = false) {
    this.setState({
      fields: { ...this.state.fields, ...fields}
    }, () => {
      if(submit) {
        this.handleSubmit();
      }
    });
  }

  render() {
    const { fields, user } = this.state;
    return (
      <div className="container">
        <div className="intro">
          <h1>UPPERCLASSDATES</h1>
          <div className="subtitle">
            Subscribing for UpperClassDates is easy and free.
          </div>
        </div>
        <form>
          <Step1
            active={this.state.currentStep === 1}
            proceed={(i) => this.handleStepChange(i + 1)}
            back={(i) => this.handleStepChange(i - 1)}
            saveData={(fields) => this.handleDataSave(fields)}
            fields={fields}
          />
          <Step2
            active={this.state.currentStep === 2}
            proceed={(i) => this.handleStepChange(i + 1)}
            back={(i) => this.handleStepChange(i - 1)}
            saveData={(fields) => this.handleDataSave(fields)}
            fields={fields}
          />
          <Step3
            active={this.state.currentStep === 3}
            proceed={(i) => this.handleStepChange(i + 1)}
            back={(i) => this.handleStepChange(i - 1)}
            saveData={(fields) => this.handleDataSave(fields)}
            fields={fields}
          />
          <Step4
            active={this.state.currentStep === 4}
            proceed={(i) => this.handleStepChange(i + 1)}
            back={(i) => this.handleStepChange(i - 1)}
            saveData={(fields) => this.handleDataSave(fields)}
            fields={fields}
          />
          <Step5
            active={this.state.currentStep === 5}
            proceed={(i) => this.handleStepChange(i + 1)}
            back={(i) => this.handleStepChange(i - 1)}
            saveData={(fields) => this.handleDataSave(fields)}
            fields={fields}
          />
          <Step6
            active={this.state.currentStep === 6}
            proceed={(i) => this.handleStepChange(i + 1)}
            back={(i) => this.handleStepChange(i - 1)}
            saveData={(fields, submit) => this.handleDataSave(fields, submit)}
            fields={fields}
          />
          <StepThankYou
            active={this.state.currentStep === 7}
            user={user}
          />
        </form>
      </div>
    );
  }
}

export default RegistrationForm;


// WEBPACK FOOTER //
// ./src/components/RegistrationForm.js